export default "__VITE_ASSET__ZwDLK7EN__"